import { toApiError } from '@core/models/api-error.model';

/**
 * Turns whatever a failed auth call threw into text the page can show:
 * the gateway's own message (or first field error) when there is one,
 * otherwise `fallback`.
 */
export function apiErrorMessage(err: unknown, fallback: string): string {
  return toApiError(err, fallback).message;
}
